import { Input, Spin } from 'antd';
import { TbSearch } from 'react-icons/tb';
import styles from './search.module.scss';
import HeaderLocationSelectComp from './locationSelect/locationSelect.index';
import { useContext, useState } from 'react';
import { GlobalContext } from 'context';
import { LocationType, ThemeEnum } from 'types';
import { usePathname } from 'next/navigation';
import { PATH } from 'data';
import { useRouter, useSearchParams } from 'next/navigation';

export default function HeaderSearchComp(props: {
    parentLocations?: LocationType<'list'>[];
    search?: string;
    noLocation?: boolean;
}) {
    const { theme } = useContext(GlobalContext);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState(props.search);
    const pathname = usePathname();
    const router = useRouter();
    const searchParams = useSearchParams();

    const onKeyDown = (key?: string) => {
        if (key === 'Enter') onSearch();
    };

    const onSearch = (s = search) => {
        if (pathname === PATH.posts()) {
            const params = new URLSearchParams(searchParams);
            const sParam = params.get('search');
            if (sParam !== s) {
                if (s?.length) params.set('search', s);
                else params.delete('search');
                router.push(PATH.posts() + '?' + params.toString());
            }
        } else if (s?.length) {
            setLoading(true);
            router.push(PATH.posts({ search: s }));
        }
    };

    return (
        <Input
            placeholder="جستجو در همه آگهی ها"
            className={`${styles['search-input']}`}
            disabled={loading}
            allowClear
            prefix={
                loading ? (
                    <Spin size="small" className="ml-1" />
                ) : (
                    <TbSearch
                        size={28}
                        className={`pl-1 pointer ${styles['search-icon']} ${theme === ThemeEnum.light ? 't-black1' : 't-gray2'}`}
                        onClick={() => onKeyDown('Enter')}
                    />
                )
            }
            onChange={(e) => {
                setSearch(e.target.value);
                if (!e.target.value.length) onSearch('');
            }}
            onClear={() => onSearch('')}
            suffix={!props.noLocation ? <HeaderLocationSelectComp parentLocations={props.parentLocations} /> : null}
            onKeyDown={(e) => onKeyDown(e.key)}
            value={search}
        />
    );
}
